module.exports = __webpack_public_path__ + "files/c7b452747c96981534179b1d2b947fc9.png";